import { createStore, applyMiddleware, compose, type Store, type AnyAction } from 'redux'
import createSagaMiddleware from 'redux-saga'
import reducers from './reducers'
import rootSaga from './rootSaga'

import { createLogger } from 'redux-logger'
import { MessageState } from './message/types'
import { ChatState } from '@/redux/chat/types'
import { UserState } from './user/types'
import { ContactState } from './contact/types'
import { CompanyState } from './company/types'
import { DepartmentState } from './department/types'
import { StickerState } from './sticker/types'
import { ChangeTheme } from './theme/types'
import { LabelState } from './label/types'
import { QuickReplyState } from './quickReply/types'
import { CampaignState } from './campaign/types'
import { CustomButtonState } from './custom-button/types'
import { FollowupState } from './followup/types'

const logger = createLogger({
  collapsed: true,
  logErrors: true,
  diff: true
}) as any

const sagaMiddleware = createSagaMiddleware({
  onError: error => {
    console.error('Saga error:', error)
  }
})

const middlewares = [sagaMiddleware, logger]

// Add support for Redux DevTools
const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export type ApplicationState = {
  companyReducer: CompanyState
  chatReducer: ChatState
  messageReducer: MessageState
  userReducer: UserState
  contactReducer: ContactState
  departmentReducer: DepartmentState
  stickerReducer: StickerState
  themeReducer: ChangeTheme
  labelReducer: LabelState
  quickReplyReducer: QuickReplyState
  campaignReducer: CampaignState
  customButtonReducer: CustomButtonState
  followupReducer: FollowupState
}

export function configureStore() {
  const store: Store<ApplicationState, AnyAction> = createStore(
    reducers,
    composeEnhancers(applyMiddleware(...middlewares))
  )

  sagaMiddleware.run(rootSaga)
  return store
}
